import {Injectable} from "@angular/core";
import {Builder, Index, trimmer} from "lunr";
import {ThingsUtil} from "../../util/things";
import {ParkService} from "@core/park/park.service";
import {ThingService} from "@core/thing/thing.service";
import {RefreshEvent} from "@events/RefreshEvent";

declare function require(url: string);

@Injectable()
export class GlobalSearchService {
  private idxPromise: Promise<Index>;

  private documentStore;

  constructor(private parkService: ParkService, private thingService: ThingService, private thingUtil: ThingsUtil,
              private refresher: RefreshEvent) {
    this.refresher.on().subscribe(data => {
      if (data == "thingsDetails.refresh" || data == "refresh.lands") {
        this.reloadDataLazy();
      }
    })
  }

  search(text: string, limit: number): Promise<any> {
    console.log("searching: " + text);
    return this._getIndex()
      .then(idx => {
        let searchResults = idx.search("*" + text + "*");

        let results = [];

        // cap limit
        let _limit = (limit ? limit : searchResults.length);
        for (let i = 0; i < searchResults.length && i < _limit; i++) {
          results.push(this.documentStore[searchResults[i].ref]);
        }

        return {
          results: results,
          count: searchResults.length
        };
      });
  }

  _getIndex(): Promise<Index> {
    if (this.idxPromise) {
      return this.idxPromise
    } else {
      return this.idxPromise = this.buildSearchIndex();
    }
  }

  reloadDataLazy(){
    this.idxPromise = undefined;
  }

  rebuildSearchIndex(): Promise<Index> {
    return this.idxPromise = this.buildSearchIndex();
  }

  buildSearchIndex(): Promise<Index> {
    console.log('building global search index');
    let start = Date.now();

    return Promise.all([
      this.parkService.getWorldsKingdomsLands(),
      this.thingService.getThingsDataPartial()
    ])
      .then(results => {
        let startIndex = Date.now();

        this.documentStore = {};
        let builder: Builder = new Builder();
        builder.pipeline.add(trimmer);
        builder.searchPipeline.add(trimmer);
        builder.ref('ref');
        builder.field('id');
        builder.field('name');
        builder.field('area');

        results[0].areas
          .map(area => {
            return {
              ref: "area-" + area.areaId,
              id: area.areaId,
              type: 'AREA',
              name: area.name,
              area: area.name,
              active: area.active != undefined ? area.active : true
            }
          })
          .forEach(indexDoc => {
            this.documentStore[indexDoc.ref] = indexDoc;
            builder.add(indexDoc);
          });

        results[1].things
          .map(thing => {
            let area = this.documentStore['area-' + thing.area];
            return {
              ref: "thing-" + thing.thingId,
              id: thing.thingId,
              type: thing.type,
              name: thing.name,
              area: area ? area.name : thing.area,
              active: this.thingUtil.isActive(thing)
            }
          })
          .forEach(indexDoc => {
            this.documentStore[indexDoc.ref] = indexDoc;
            builder.add(indexDoc);
          });

        let idx : Index = builder.build();
        let end = Date.now();
        console.log("finished building index: " + ((end - start) / 1000) + ' sec(s)');

        return idx;
      })
  }
}



// WEBPACK FOOTER //
// D:/dclean-web-latest/task/cot-web/src/app/core/globalSearch/globalSearch.service.ts